/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * agora/v1/organization.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  CurrentUserOrganizationsParams,
  DeleteOrganization200,
  DeleteOrganizationParams,
  RpcStatus,
  UpdateOrganizationBody,
  V1CurrentUserOrganizationsResponse,
  V1ListOrganizationOwnersRequest,
  V1ListOrganizationOwnersResponse,
  V1Organization,
} from '../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary Lists owners for all organizations accessible to the current user.
 */
export const listOrganizationOwners = (
  v1ListOrganizationOwnersRequest: V1ListOrganizationOwnersRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListOrganizationOwnersResponse>> => {
  return axios.default.post(
    `/agora.v1.OrganizationService/ListOrganizationOwners`,
    v1ListOrganizationOwnersRequest,
    options,
  );
};

export const getListOrganizationOwnersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listOrganizationOwners>>,
    TError,
    { data: V1ListOrganizationOwnersRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listOrganizationOwners>>,
  TError,
  { data: V1ListOrganizationOwnersRequest },
  TContext
> => {
  const mutationKey = ['listOrganizationOwners'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listOrganizationOwners>>,
    { data: V1ListOrganizationOwnersRequest }
  > = props => {
    const { data } = props ?? {};

    return listOrganizationOwners(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListOrganizationOwnersMutationResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizationOwners>>
>;
export type ListOrganizationOwnersMutationBody =
  V1ListOrganizationOwnersRequest;
export type ListOrganizationOwnersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Lists owners for all organizations accessible to the current user.
 */
export const useListOrganizationOwners = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listOrganizationOwners>>,
      TError,
      { data: V1ListOrganizationOwnersRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listOrganizationOwners>>,
  TError,
  { data: V1ListOrganizationOwnersRequest },
  TContext
> => {
  const mutationOptions = getListOrganizationOwnersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists all organizations that the current user is a member of.
 */
export const currentUserOrganizations = (
  params?: CurrentUserOrganizationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CurrentUserOrganizationsResponse>> => {
  return axios.default.get(`/api/v1/me/organizations`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getCurrentUserOrganizationsQueryKey = (
  params?: CurrentUserOrganizationsParams,
) => {
  return [`/api/v1/me/organizations`, ...(params ? [params] : [])] as const;
};

export const getCurrentUserOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof currentUserOrganizations>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: CurrentUserOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCurrentUserOrganizationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof currentUserOrganizations>>
  > = ({ signal }) =>
    currentUserOrganizations(params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof currentUserOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CurrentUserOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentUserOrganizations>>
>;
export type CurrentUserOrganizationsQueryError = AxiosError<RpcStatus>;

export function useCurrentUserOrganizations<
  TData = Awaited<ReturnType<typeof currentUserOrganizations>>,
  TError = AxiosError<RpcStatus>,
>(
  params: undefined | CurrentUserOrganizationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserOrganizations>>,
          TError,
          Awaited<ReturnType<typeof currentUserOrganizations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserOrganizations<
  TData = Awaited<ReturnType<typeof currentUserOrganizations>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: CurrentUserOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserOrganizations>>,
          TError,
          Awaited<ReturnType<typeof currentUserOrganizations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserOrganizations<
  TData = Awaited<ReturnType<typeof currentUserOrganizations>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: CurrentUserOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all organizations that the current user is a member of.
 */

export function useCurrentUserOrganizations<
  TData = Awaited<ReturnType<typeof currentUserOrganizations>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: CurrentUserOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCurrentUserOrganizationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a new organization.
 */
export const createOrganization = (
  v1Organization: NonReadonly<V1Organization>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Organization>> => {
  return axios.default.post(`/api/v1/organizations`, v1Organization, options);
};

export const getCreateOrganizationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganization>>,
    TError,
    { data: NonReadonly<V1Organization> },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  { data: NonReadonly<V1Organization> },
  TContext
> => {
  const mutationKey = ['createOrganization'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganization>>,
    { data: NonReadonly<V1Organization> }
  > = props => {
    const { data } = props ?? {};

    return createOrganization(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganization>>
>;
export type CreateOrganizationMutationBody = NonReadonly<V1Organization>;
export type CreateOrganizationMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new organization.
 */
export const useCreateOrganization = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrganization>>,
      TError,
      { data: NonReadonly<V1Organization> },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  { data: NonReadonly<V1Organization> },
  TContext
> => {
  const mutationOptions = getCreateOrganizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets details of a specific organization.
 */
export const getOrganization = (
  organization: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Organization>> => {
  return axios.default.get(`/api/v1/organizations/${organization}`, options);
};

export const getGetOrganizationQueryKey = (organization?: string) => {
  return [`/api/v1/organizations/${organization}`] as const;
};

export const getGetOrganizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationQueryKey(organization);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({
    signal,
  }) => getOrganization(organization, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganization>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError = AxiosError<RpcStatus>;

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets details of a specific organization.
 */

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrganizationQueryOptions(organization, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes an organization.
This performs a soft-delete.
 */
export const deleteOrganization = (
  organization: string,
  params?: DeleteOrganizationParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteOrganization200>> => {
  return axios.default.delete(`/api/v1/organizations/${organization}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDeleteOrganizationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganization>>,
    TError,
    { organization: string; params?: DeleteOrganizationParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganization>>,
  TError,
  { organization: string; params?: DeleteOrganizationParams },
  TContext
> => {
  const mutationKey = ['deleteOrganization'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganization>>,
    { organization: string; params?: DeleteOrganizationParams }
  > = props => {
    const { organization, params } = props ?? {};

    return deleteOrganization(organization, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrganization>>
>;

export type DeleteOrganizationMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes an organization.
This performs a soft-delete.
 */
export const useDeleteOrganization = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrganization>>,
      TError,
      { organization: string; params?: DeleteOrganizationParams },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganization>>,
  TError,
  { organization: string; params?: DeleteOrganizationParams },
  TContext
> => {
  const mutationOptions = getDeleteOrganizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates an existing organization.
 */
export const updateOrganization = (
  organization: string,
  updateOrganizationBody: NonReadonly<UpdateOrganizationBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Organization>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}`,
    updateOrganizationBody,
    options,
  );
};

export const getUpdateOrganizationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganization>>,
    TError,
    { organization: string; data: NonReadonly<UpdateOrganizationBody> },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  { organization: string; data: NonReadonly<UpdateOrganizationBody> },
  TContext
> => {
  const mutationKey = ['updateOrganization'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganization>>,
    { organization: string; data: NonReadonly<UpdateOrganizationBody> }
  > = props => {
    const { organization, data } = props ?? {};

    return updateOrganization(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganization>>
>;
export type UpdateOrganizationMutationBody =
  NonReadonly<UpdateOrganizationBody>;
export type UpdateOrganizationMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates an existing organization.
 */
export const useUpdateOrganization = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganization>>,
      TError,
      { organization: string; data: NonReadonly<UpdateOrganizationBody> },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  { organization: string; data: NonReadonly<UpdateOrganizationBody> },
  TContext
> => {
  const mutationOptions = getUpdateOrganizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
